import clsx from "clsx";

export default function HeadingStyle({ level, text, className, children }) {
    level = level ? level : 4;
    const HeadingTag = `h${level}`;
    const headingClasses = className === null || className === undefined ? 'text-4xl' : null
    return (
        <HeadingTag className={clsx(headingClasses, className)}>{text || children}</HeadingTag>
    )
}